module.exports = __webpack_public_path__ + "img/cedre.e920ec65.jpg";